import React, { useEffect } from 'react';

import {
  ChatMediaViewerBody,
  ChatMediaViewerFrame,
  ChatMediaViewerImage,
  ChatMediaViewerOverlay,
  ChatMediaViewerPanel,
  ChatMediaViewerTitle,
  ChatMediaViewerToolbar,
  ChatMediaViewerToolbarButton,
} from './chatsWhatsapp.styles';

const ChatMediaViewerModal = ({ viewer, onClose, onDownload, onOpenExternal }) => {
  useEffect(() => {
    if (!viewer) {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose, viewer]);

  if (!viewer) {
    return null;
  }

  return (
    <ChatMediaViewerOverlay onClick={onClose} role="presentation">
      <ChatMediaViewerPanel onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true">
        <ChatMediaViewerToolbar>
          <ChatMediaViewerTitle title={viewer.filename}>{viewer.filename}</ChatMediaViewerTitle>
          <div>
            {typeof onDownload === 'function' && (
              <ChatMediaViewerToolbarButton type="button" onClick={onDownload}>
                Baixar
              </ChatMediaViewerToolbarButton>
            )}
            {viewer.external && typeof onOpenExternal === 'function' && (
              <ChatMediaViewerToolbarButton type="button" onClick={onOpenExternal}>
                Nova aba
              </ChatMediaViewerToolbarButton>
            )}
            <ChatMediaViewerToolbarButton type="button" onClick={onClose}>
              Fechar
            </ChatMediaViewerToolbarButton>
          </div>
        </ChatMediaViewerToolbar>
        <ChatMediaViewerBody>
          {viewer.mode === 'image' ? (
            <ChatMediaViewerImage src={viewer.url} alt={viewer.filename} />
          ) : (
            <ChatMediaViewerFrame src={viewer.url} title={viewer.filename} />
          )}
        </ChatMediaViewerBody>
      </ChatMediaViewerPanel>
    </ChatMediaViewerOverlay>
  );
};

export default ChatMediaViewerModal;
